import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const wrapperStyles = {
  '& div[role="tablist"]': {
    gap: '4px',
  },
};

export const getTabStyles = (customStyles, isDeleted) => ({
  minHeight: 'unset',
  fontSize: '1.2rem',
  fontWeight: 400,
  textTransform: 'none',
  borderRadius: '8px',
  padding: '0 32px',
  height: '38px',
  alignItems: 'flex-start',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },

  '&[aria-selected="true"]': {
    backgroundColor: ({ palette }) => palette.background.secondary,
    color: ({ palette }) => palette.primary.main,
  },

  ...getConditionalObject(isDeleted, {
    textDecoration: 'line-through',
    textDecorationThickness: '1px',
    color: ({ palette }) => `${palette.text.secondary} !important`,
    opacity: 0.5,
  }),

  ...customStyles,
});

export const indicatorStyles = {
  width: '8px',
  left: 0,
  borderTopLeftRadius: '8px',
  borderBottomLeftRadius: '8px',
  background: `linear-gradient(to right, ${COLOR_PALETTE.BRAND[6]} 4px, transparent 4px)`,
};
